import { createFeatureSelector, createSelector } from '@ngrx/store';

import { DebugBarState } from './debugbar.state';

export const selectDebugBarState = createFeatureSelector<DebugBarState>('debugbar');

export const getDebugBarActiveStatus = createSelector(selectDebugBarState, (state: DebugBarState) => state?.isActive);
export const getDebugBarOpenStatus = createSelector(selectDebugBarState, (state: DebugBarState) => state?.isOpen);
export const getDebugBarRtlStatus = createSelector(selectDebugBarState, (state: DebugBarState) => state?.isRtl);
export const getDebugBarShowTranslationsStatus = createSelector(
    selectDebugBarState,
    (state: DebugBarState) => state?.showTranslations
);
export const getDebugBarUserType = createSelector(selectDebugBarState, (state: DebugBarState) => state?.userIsVip);
export const getDebugBarFontHelperStatus = createSelector(
    selectDebugBarState,
    (state: DebugBarState) => state?.fontHelperEnabled
);
export const getDebugBarShowProductsInfoStatus = createSelector(
    selectDebugBarState,
    (state: DebugBarState) => state?.showProductsInfo
);
export const getDebugBarShowCategoryIdsStatus = createSelector(
    selectDebugBarState,
    (state: DebugBarState) => state?.showCategoryIds
);

export const getDebugBarShowTimeTraveller = createSelector(
    selectDebugBarState,
    (state: DebugBarState) => state?.timeTraveller
);

export const getDebugBarShowTimeTravellerStatus = createSelector(
    selectDebugBarState,
    (state: DebugBarState) => state?.timeTraveller?.showTimeTraveller
);
export const getTimeTravellerDate = createSelector(
    selectDebugBarState,
    (state: DebugBarState) => state?.timeTraveller?.date
);

export const getDebugBarShowCmsTooltipsStatus = createSelector(
    selectDebugBarState,
    (state: DebugBarState) => state?.showCmsTooltips
);
